import { Plus, Search } from 'lucide-react';
import { ListSkeleton } from '../receptura/RecipeListPanel';

/**
 * Kostra levého seznamu — karta, čtvercové „+“, hledání, skeleton a prázdné stavy.
 *
 * Vznikla proto, aby se seznam materiálů a seznam balicích předpisů nemohly
 * rozejít. Obsah (strom kategorií nebo prostý výpis) je `children`, extra
 * ovládání pod hledáním jde přes `filtry`.
 */
export default function SeznamPanel({
    isMobile, isDark, mutedColor, cardStyle, inputStyle, akcent,
    search, setSearch, hledatPlaceholder, novyTitle, onNew,
    filtry = null,
    loading = false,
    prazdne = null,       // { Icon, text, akce } — když seznam nic nevrací
    prazdneHledani = false,
    children,
}) {
    return (
        <div className="flex flex-col" style={{
            width: isMobile ? '100%' : '25vw', minWidth: isMobile ? 'auto' : 320,
            maxWidth: isMobile ? 'none' : 520, flexShrink: 0,
        }}>
            <div className="rounded-xl overflow-hidden flex flex-col" style={{ ...cardStyle, flex: 1 }}>
                {/* Filtry */}
                <div className="p-3 space-y-2" style={{ borderBottom: `1px solid ${isDark ? 'rgba(255,255,255,0.10)' : 'var(--border-default)'}` }}>
                    <div className="flex gap-2">
                        <button onClick={onNew} title={novyTitle}
                            className="flex items-center justify-center rounded-lg"
                            style={{ background: akcent, color: '#fff', border: 'none', cursor: 'pointer', width: 32, flexShrink: 0 }}>
                            <Plus size={16} />
                        </button>
                        <div style={{ position: 'relative', flex: 1 }}>
                            <Search size={14} style={{ position: 'absolute', left: 10, top: 10, color: mutedColor }} />
                            <input placeholder={hledatPlaceholder} value={search} onChange={e => setSearch(e.target.value)}
                                style={{ ...inputStyle, paddingLeft: 30, fontSize: 12 }} />
                        </div>
                    </div>
                    {filtry}
                </div>

                {/* Obsah */}
                <div className="overflow-y-auto flex-1" style={{ flex: 1, minHeight: 0 }}>
                    {loading ? (
                        <ListSkeleton isDark={isDark} />
                    ) : prazdne ? (
                        prazdneHledani ? (
                            <p className="text-center text-xs py-8" style={{ color: mutedColor }}>Nic nenalezeno pro „{search}“</p>
                        ) : (
                            <div className="text-center px-6 py-10">
                                {prazdne.Icon && <prazdne.Icon size={28} style={{ color: mutedColor, opacity: 0.5, margin: '0 auto 10px' }} />}
                                <p className="text-xs" style={{ color: mutedColor }}>{prazdne.text}</p>
                                {prazdne.akce && (
                                    <button onClick={onNew} className="flex items-center gap-1 mt-3 mx-auto rounded-lg"
                                        style={{ background: akcent, color: '#fff', border: 'none', cursor: 'pointer', padding: '5px 12px', fontSize: 12, fontWeight: 600 }}>
                                        <Plus size={13} /> {prazdne.akce}
                                    </button>
                                )}
                            </div>
                        )
                    ) : children}
                </div>
            </div>
        </div>
    );
}
